<template>
  <HomeProgramsShowcase :schools="homeShowcases.schools" />
  <HomeJobsShowcase :professions="homeShowcases.professions" />
  <HomeAdviceShowcase :articles="homeShowcases.articles" />
</template>

<script setup lang="ts">
const { homeShowcases } = useHomeShowcasesData()
</script>
